import axios from "./axios";

export const resolveApiFileUrl = (fileReference) => {
  if (!fileReference || typeof fileReference !== "string") return "";
  if (/^(data:|blob:|https?:\/\/)/i.test(fileReference)) return fileReference;

  const apiBase = new URL(
    axios.defaults.baseURL || window.location.origin,
    window.location.origin,
  );
  const versionIndex = apiBase.pathname.lastIndexOf("/v1");
  const apiPrefix = versionIndex >= 0 ? apiBase.pathname.slice(0, versionIndex) : "";
  const normalizedPath = fileReference.startsWith("/") ? fileReference : `/${fileReference}`;

  if (apiPrefix && !normalizedPath.startsWith(`${apiPrefix}/`)) {
    return new URL(`${apiPrefix}${normalizedPath}`, apiBase.origin).toString();
  }
  return new URL(normalizedPath, apiBase.origin).toString();
};
